// extracted by mini-css-extract-plugin
export var fullHeight = "styles-module--fullHeight--5p+ab";